
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-studio/prompting-guide",
      function () {
        return require("private-next-pages/ad-studio/prompting-guide.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-studio/prompting-guide"])
      });
    }
  